import axios from 'axios';
import store from "../store";
import { serverUrl } from '../common/js/constant';
import { Toast, Dialog } from 'vant';
import { getToken } from '@/utils/auth'
import { removeUser, removeToken } from '@/utils/auth'
import router from '@/router'
// create an axios instance
const service = axios.create({
    baseURL: serverUrl, // 默认请求地址
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 20000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(
    config => {
        // config.headers['X-TenantId'] = 'alibaba'
        config.headers['X-Token'] = store.state.token
        // if (getToken()) {
        //     config.headers['X-Token'] = getToken()
        // }
        // alert('token:' + config.headers['X-Token'])
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code == 401) {
            //token过期
            removeToken()
            store.dispatch('getPhone').then(res => {
                // alert(response.config['X-Token'])
                // alert(JSON.stringify(res))
                response.config['X-Token'] = res
                service(response.config)
                console.log(res)
            }).catch(err => {
                Dialog(err)
                // alert(err)
            })
        } else if (res.code && res.code !== 200) {
            Dialog({
                message: res.message || 'error',
                closeOnClickOverlay: true
            })
            // alert(res.message || 'error')
            return Promise.reject(res || 'error')
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Dialog({
            message: `接口请求失败`
        })
        // alert('接口请求失败')
        return Promise.reject(error)
    }
)

export default service
